<template>
    <dl>
        <div v-if="getCountryRaceCount(meetingsSelection ,meetings) > 0" class="mb-10 lg:mb-0">
            <div v-for="(meeting, index) in meetings" :key="meeting.id">
                <a href="https://racingstars.co.uk/league/dya6tn">
                    <div v-if="index === 1 && $page.props.features.ad_message === true" class="text-left h-[151px] w-full bg-gray-900 backdrop-blur justify-between items-start text-gray-400 transition ease-in-out meeting border-2 border-racing-stars-trans rounded-lg mt-2 drop-shadow-sm">
                        <span class=" grow flex justify-center mb-1 space-between font-bold m-2">
                            <span class="space-x-1 flex flex-col">
                        <span class="text-white text-lg lg:text-xl text-center">
                            Win a share in a racehorse!
                        </span>
                        <span class="text-white font-normal text-center mt-2 text-sm">
                           Top scorer across the week gets the prize! Click to view the current standings.
                        </span>
                        <span class="text-white font-normal text-xs text-center mt-2">
                           Courtesy of our partners at
                        </span>
                        <span>
                            <img class="w-40 lg:w-44 mx-auto" :src="asset('images/mrh.png')" alt="Myracehorse"/>
                        </span>
                    </span>
                </span>
                </div>
                </a>
            <Disclosure  as="div" v-slot="{ open }">
                <span class = "overflow-y: scroll; height:400px;">
                        <span v-if="(user.is_admin === 1 || meeting.hidden !== 1)">
                            <dt v-if="!meeting.abandoned" class="text-lg" >
                                <DisclosureButton
                                    class="text-left w-full justify-between items-start text-gray-400 transition ease-in-out meeting border-2 border-racing-stars-trans rounded-lg mt-2 drop-shadow-sm"
                                    :class="[
                                                    open ? 'rounded-t-lg rounded-b-none border-b-0' : '',
                                                    meeting.featured ? 'border border-racing-stars-trans rounded-lg bg-center bg-contain bg-no-repeat bg-gradient-to-b from-gray-950 to-gray-900': 'bg-gradient-to-r from-racing-stars-dirty-yellow to-deep-blue',
                                                    meeting.jackpot.price === 0 ? 'border border-green-400 rounded-lg': '',
                                                ]"
                                    @click="getRaces(meeting.id, open)"
                                    id="meetingButton"
                                    as="button">

                                                  <span v-if="meeting.featured && (!meeting.banner || meeting.banner === '')" class=" grow flex mb-1 space-between font-bold m-2">
                                                        <span class="space-x-1" v-if=" meeting.featured || meeting.jackpot.price === 0">
                                                            <span v-if="meeting.featured" class="border border-racing-stars-yellow text-sm rounded p-1 px-2 text-racing-stars-yellow">
                                                                <StarIcon class="text-racing-stars-yellow w-4 inline-block " /> Featured
                                                            </span>
                                                            <!-- <span v-if="meeting.jackpot.price === 0 && meeting.featured" class="border border-green-400 text-sm rounded p-1 px-2 text-green-400">
                                                                <DatabaseIcon class="w-4 inline-block text-green-400" />Free to play
                                                            </span> -->
                                                    </span>
                                                    </span>

                                                  <div v-if="meeting.featured && meeting.banner" class="h-[156px] bg-center bg-contain bg-no-repeat bg-origin-border mb-3"
                                                       :style="meeting.banner && 'background-image: url(\'' + meeting.banner_new + '\'), linear-gradient(rgb(3, 7, 18), rgb(17, 24, 39));'"
                                                  >
                                                    <span class=" grow flex mb-1 space-between font-bold m-2.5">
                                                        <span class="space-x-1" v-if=" meeting.featured || meeting.jackpot.price === 0">
                                                            <span v-if="meeting.featured" class="text-sm rounded p-1 px-2 text-racing-stars-yellow">
                                                                <StarIcon class="text-racing-stars-yellow w-4 inline-block " /> Featured
                                                            </span>
                                                            <!-- <span v-if="meeting.jackpot.price === 0 && meeting.featured" class="border border-green-400 text-sm rounded p-1 px-2 text-green-400">
                                                                <DatabaseIcon class="w-4 inline-block text-green-400" />Free to play
                                                            </span> -->
                                                        </span>
                                                    </span>
                                                  </div>

                                    <span class="flex justify-between mb-1 font-bold space-x-1 sm:space-x-2 p-2.5">
                                        <span class="font-bold text-racing-stars-yellow capitalize text-sm md:text-lg grow flex items-center">

                                            <CheckCircleIcon class="mr-0 sm:mr-1 w-7 text-racing-stars-yellow" v-if="hasBet(meeting)" />

                                            <span v-if="meeting.hidden === 1"> <b>{{ meeting.name }} (Hidden) {{title}} </b> </span>
                                            <span v-else-if="meeting.featured"><b>{{ meeting.name }}</b> </span>

                                            <span v-else-if="meeting.jackpot.price === 0"><DatabaseIcon class="w-4 inline-block text-green-400" /> <span class="text-green-400 text-lg">{{ meeting.name }}</span></span>
                                            <span v-else-if="meeting.jackpot.price === 0 && !meeting.featured"><span class="text-green-400 text-lg">{{ meeting.name }}</span></span>

                                            <span v-else>{{ meeting.name }}</span>
                                        </span>
                                    </span>

                                    <span class="flex justify-between space-x-1 sm:space-x-2 px-2.5">
                                        <span class="flex">
                                            <span v-if="meeting?.jackpot?.prize_detail?.[0] !== undefined " class="flex grow-0 items-center py-0.5 text-sm font-normal text-white mr-1">
                                                <svg class="w-5 h-5 mr-0.5 sm:mr-1" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 002.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 012.916.52 6.003 6.003 0 01-5.395 4.972m0 0a6.726 6.726 0 01-2.749 1.35m0 0a6.772 6.772 0 01-3.044 0" stroke-linecap="round" stroke-linejoin="round"></path>
                                                </svg>

                                                <Popper v-if="meeting.jackpot.prize_detail" placement="right" arrow="true" :hover="true">
                                                    <!-- Trigger -->
                                                    <span class="flex grow-0 items-center py-0.5 text-sm font-normal text-white">
                                                        <span class="inline-flex px-2 py-0.5 my-auto text-xs sm:text-sm font-medium text-white rounded-full bg-gray-700">
                                                            <span v-if="meeting.jackpot.prize_detail[0].type == 'cash'">£{{ totalCashPrize(meeting.jackpot.prize_detail)}}</span>
                                                            <span v-else>{{meeting.jackpot.prize_detail[0].amount}}</span>
                                                            <img v-if="meeting.jackpot.prize_detail[0].type == 'cash'" class="w-4 h-4 my-auto ml-1" :src="asset('images/coin-and-tokens/cash.svg')" />
                                                            <img v-if="meeting.jackpot.prize_detail[0].type == 'token'" class="w-4 h-4 my-auto ml-1" :src="asset('images/coin-and-tokens/stars-small.svg')" />
                                                        </span>
                                                    </span>
                                                    <!-- Tooltip Content -->
                                                    <template #content>
                                                        <div class="p-1 rounded-md text-white text-xs sm:text-sm z-20">
                                                            <div v-for="(prize, index) in meeting.jackpot.prize_detail.slice(0, 3)" :key="index" class="flex items-center">
                                                                <span class="mr-2">{{ prize.place + ordinalIndicator(prize.place) }} Place:</span>
                                                                <span class="inline-flex items-center">
                                                                    <span class="font-bold text-white">{{ prize.type == 'cash' ? '£' + prize.amount : prize.amount }}</span>
                                                                    <img v-if="prize.type == 'cash'" class="w-4 h-4 my-auto ml-1" :src="asset('images/coin-and-tokens/cash.svg')" />
                                                                    <img v-if="prize.type == 'token'" class="w-4 h-4 my-auto ml-1" :src="asset('images/coin-and-tokens/stars-small.svg')" />
                                                                </span>
                                                            </div>
                                                            <div class="font-medium">View prizes for the full list </div>
                                                        </div>
                                                    </template>
                                                </Popper>
                                            </span>
                                            <span v-if="$page.props.features.entry_price === true" class="flex">
                                            <span class="flex grow-0 items-center py-0.5 text-sm font-normal text-white">
                                                <TicketIcon class="w-5 h-5 mr-0.5 sm:mr-1" />
                                                <span class="px-2 py-0.5 my-auto text-xs sm:text-sm font-medium text-white rounded-full bg-gray-700">
                                                    <span class="inline-flex items-center">
                                                        <Popper content="Entry cost to meeting" placement="top" arrow="true" :hover="true">
                                                            <span v-if="meeting.jackpot.price > 0" class="inline-flex my-auto text-xs sm:text-sm font-medium text-white rounded-full bg-gray-700">
                                                                <p class="my-auto text-sm">{{ meeting.jackpot.price }}</p>
                                                                <img class="w-4 h-4 my-auto ml-1" :src="asset('images/coin-and-tokens/token-optimised.svg')" />
                                                            </span>

                                                            <p v-else class="my-auto text-sm" >Free Entry</p>
                                                        </Popper>
                                                    </span>
                                                </span>
                                            </span>
                                            </span>
                                        </span>

                                        <button @click="openModal(meeting.id)" @click.stop class="flex grow-0 items-center py-0.5 text-sm font-normal text-white">
                                            <span class="inline-flex px-2 py-0.5 my-auto text-sm font-semibold text-white rounded-full bg-gray-700 border">
                                                View Prizes
                                            </span>
                                        </button>
                                        <Dialog as="div" :open="isVisible(meeting.id)" class="fixed z-10 inset-0 overflow-y-auto flex items-center justify-center" @close="isOpen = false">
                                            <div class="flex items-center justify-center z-10 min-h-screen text-center sm:p-0 w-screen">
                                                <DialogPanel as="div" class="flex flex-col my-auto align-middle justify-center border border-gray-200 bg-gradient-to-r from-gray-800 via-gray-700 to-gray-800 w-[80%] lg:w-1/4 h-fit text-white rounded-md p-1 font-semibold">
                                                    <DialogTitle class="text-3xl m-3 flex justify-center">
                                                        <svg class="w-10 h-10 mr-0.5 sm:mr-1" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 002.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 012.916.52 6.003 6.003 0 01-5.395 4.972m0 0a6.726 6.726 0 01-2.749 1.35m0 0a6.772 6.772 0 01-3.044 0" stroke-linecap="round" stroke-linejoin="round"></path>
                                                        </svg>
                                                        <div class="my-auto">Prizes</div>
                                                    </DialogTitle>
                                                    <DialogDescription class="font-medium">
                                                        <div v-for="(prize, index) in meeting.jackpot.prize_detail" :key="index" class="flex justify-center mb-2">
                                                            <span class="my-auto lg:text-xl">{{prize.place}}{{ordinalIndicator(prize.place)}} - {{prize.type === 'cash' ? '£' : ''}}{{prize.amount}}</span>
                                                            <img v-if="prize.type !== 'named'" class="w-8 h-8 my-auto ml-1"
                                                                :src="asset(`images/coin-and-tokens/${prize.type === 'cash' ? 'cash.svg' : 'stars-small.svg'}`)"
                                                            />
                                                        </div>
                                                        <div class="px-2 mx-auto bg-gray-600 border font-semibold w-1/4 my-3 rounded-md cursor-pointer" @click="isOpen = false">Close</div>
                                                    </DialogDescription>
                                                </DialogPanel>
                                            </div>
                                            <div class="fixed inset-0 bg-gray-500 bg-opacity-30 transition-opacity"></div>
                                        </Dialog>
                                    </span>

                                    <span class="flex justify-between my-1.5 px-2.5 ">
                                        <span v-if="meeting.pre_meeting_weather !== null" class="h-7 flex grow-0 items-center text-white text-sm font-bold justify-end">
                                            <span >
                                                <img class="w-7 h-7 my-auto mr-2" :src="asset('images/weather-conditions/' + meeting.pre_meeting_weather + '.svg')" />
                                            </span>

                                            {{ meeting.pre_meeting_weather.substring(1, meeting.pre_meeting_weather.length-1)}}
                                        </span>
                                        <span v-else class="h-7 flex grow-0 items-center text-white text-sm font-bold justify-end"></span>
                                        <span class="flex grow-0 items-center py-1 text-sm font-normal text-white h-7 my-auto">
                                            <UsersIcon class="w-5 h-5 mr-0.5 sm:mr-1" />

                                            <Popper content="People joined" placement="top" arrow="true">
                                                <span class="px-2 py-1 my-auto text-sm font-medium text-white rounded-full bg-gray-700">
                                                    {{ meeting.bets.length }} Players
                                                </span>
                                            </Popper>
                                        </span>
                                    </span>
                                    <span class="flex justify-between items-center px-2.5 ">
                                        <span class="flex justify-between items-center">
                                            <span class="h-7 flex-grow-0 items-center text-white text-xs sm:text-sm font-bold justify-end">
                                                <span>{{ meeting.races_count }} Races</span>
                                            </span>

                                            <span class="ml-2 h-7 flex-grow-0 items-center text-white text-xs sm:text-sm font-bold justify-end relative flex pb-2" v-if="meeting.meeting_start === 'Live'">
                                                <span class="flex h-3 w-3 mr-2 relative mb-1 md:mb-0">
                                                    <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                                                    <span class="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
                                                </span>
                                                <span class="uppercase font-bold mb-1 md:mb-0">{{ meeting.meeting_start }}</span>
                                            </span>

                                            <span class="ml-2 h-7 flex-grow-0 items-center text-white text-xs sm:text-sm font-bold justify-end flex pb-2" v-else-if="meeting.meeting_start === 'Completed'">
                                                <span class="uppercase font-bold">{{ meeting.meeting_start }}</span>
                                            </span>

                                            <span class="ml-2 h-7 flex grow-0 text-white text-xs sm:text-sm font-bold justify-end" v-else>
                                                <span><ClockIcon class="text-white w-4 mr-1 md:mt-[2px]" /></span>
                                                <span>{{ meeting.meeting_start }}</span>
                                            </span>
                                        </span>

                                        <span class="flex ml-6 h-7 items-center justify-self-end">
                                            <ChevronDownIcon :class="[open ? '-rotate-180' : 'rotate-0', 'h-6 w-6 transform', meeting.featured ? 'text-white' : 'text-white']" aria-hidden="true" />
                                        </span>
                                    </span>

                    </DisclosureButton>
                    </dt>
                    <dt class="text-lg" v-else>
                            <div class="text-left w-full flex justify-between items-start text-gray-400 p-3 transition ease-in-out grid grid-cols-1 rounded-lg" :class="[open ? ' bg-gray-500' : 'bg-gradient-to-r from-gray-900 to-gray-800 border-2 border-red-500 mt-2']" @click="getRaces(meeting.id, open)">
                                <span class="grid grid-cols-1">
                                    <span class="font-bold text-red-500 capitalize text-sm md:text-lg">
                                        <span><XCircleIcon class="w-[1.8rem] h-[1.8rem] inline-block text-red-500 ml-0 mr-1" />  {{ meeting.name }} </span>
                                        <span class="text-sm font-bold text-gray-100 flex" v-if="meeting.abandoned">Meeting Abandoned</span>
                                    </span>
                                </span>
                            </div>
                        </dt>

                        <DisclosurePanel as="dd" class="p-2 bg-gray-500 border-racing-stars-trans border-2 rounded-b-lg bg-gradient-to-r from-racing-stars-dirty-yellow to-deep-blue w-full drop-shadow-2xl" >
                                <race-stepper :meeting="meeting" :races="races[meeting.id]" :bets="bets" :user="$page.props.user" :showPercentage="showPercentage"/>
                        </DisclosurePanel>
                    </span>
                    </span>
            </Disclosure>
            </div>
        </div>
        <p v-else class="text-center pt-3 pb-3">No races available for your search criteria. <br>Please try a different country or date.</p>
    </dl>
</template>
<script>
import { reactive, onMounted, computed } from 'vue'
import { Disclosure, DisclosureButton, DisclosurePanel, Dialog, DialogPanel, DialogTitle, DialogDescription, DialogOverlay } from '@headlessui/vue'
import { ChevronDownIcon, ClockIcon, DatabaseIcon, UsersIcon, CheckCircleIcon, StarIcon, FireIcon, ArrowsExpandIcon, XCircleIcon, TicketIcon } from '@heroicons/vue/outline';
import { ExclamationCircleIcon } from '@heroicons/vue/solid';
import StepTwoCard from './tutorials/StepTwoCard.vue';
import StepThreeCard from './tutorials/StepThreeCard.vue';
import StepFourCard from './tutorials/StepFourCard.vue';
import StepFiveCard from './tutorials/StepFiveCard.vue';
import StepSixCard from './tutorials/StepSixCard.vue';
import RaceStepper from '@/Global/Play/Partials/RaceStepper';
import Popper from "vue3-popper"
import {ref} from "vue"


export default {
    name: "MeetingsAccordian",

    props: {
        meetings: {
            type: Object,
            default: {}
        },
        user: {
            type: Object,
            default: {}
        },
        bets: {
            type: Array,
            default: []
        },
        meetingsSelection: {
            type: String,
            default: "GB"
        }

    },

    components: {
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        ChevronDownIcon,
        ClockIcon,
        DatabaseIcon,
        UsersIcon,
        CheckCircleIcon,
        StarIcon,
        FireIcon,
        ArrowsExpandIcon,
        Popper,
        XCircleIcon,
        TicketIcon,
        Dialog,
        DialogPanel,
        DialogTitle,
        DialogDescription,
        DialogOverlay,
        ExclamationCircleIcon,
        DialogOverlay,
        ExclamationCircleIcon,
    },
    data() {
        return {
            showPercentage:this.getStoredProbabilityPref(),
            isOpen : true,
            url:process.env.MIX_APP_URL,
            visibleMeetingId: null,
        };
    },
    methods: {

        totalCashPrize: function (prize_details) {
            let total = 0;
            for (let prize of prize_details) {
            if (prize.type === 'cash') {
                total += Number(prize.amount);
            }
        }
        return total;
        },

        singleDisclosureCheck() {
            if (this.getCountryRaceCount(this.meetingsSelection, this.meetings) === 1) {
                this.$nextTick(() => {
                    this.forceDisclosureOpen();
                });
            }
        },

        forceDisclosureOpen() {
            const disclosureButton = document.getElementById('meetingButton')
            if (disclosureButton) {
                disclosureButton.click()
            }
        },

        activeCountry(countryCode){
            this.meetingsSelection = countryCode

            // Store value of previously selected countryCode in cookies to continue on page later
            localStorage.setItem('countryCode', countryCode)
        },

        // Get stored country code from local user storage

        getStoredCountryCode() {
            let storedCountryCode = localStorage.getItem('countryCode')
            if (storedCountryCode) {
                return storedCountryCode
            }
            return 'GB'
        },

        // Get stored implied probability preference from local user storage
        getStoredProbabilityPref() {
            let storedProbabilityPref = localStorage.getItem('showImpliedProbability')

            if (storedProbabilityPref) {
                return (localStorage.getItem('showImpliedProbability') === 'true')
            }

            return false
        },

        // Allows us to return to default selections on page on user refresh
        resetSessionStorage() {
            localStorage.setItem('countryCode', 'GB')
        },

        ordinalIndicator(number) {
            const j = number % 10,
                k = number % 100;
            if (j == 1 && k != 11) {
                return "st";
            }
            if (j == 2 && k != 12) {
                return "nd";
            }
            if (j == 3 && k != 13) {
                return "rd";
            }
            return "th";
        },


        // Returns int count of races for a given country code
        getCountryRaceCount(countryCode, meetings) {
            let meetingsByCountry = meetings.filter(obj=> obj.country_code == countryCode);

            // If user is admin, skip filtering of hidden meetings
            if (this.user.is_admin) {
                return meetingsByCountry.length
            }

            return meetingsByCountry.filter(obj => obj.hidden == 0).length
        }
    },
    created(){
        window.addEventListener('beforeunload', this.resetSessionStorage);
    },

    mounted() {
        this.singleDisclosureCheck();
        this.componentDisplayed = true;
    },

    watch: {
        meetingsSelection() {
            this.singleDisclosureCheck();
        },
    },

    setup(props, {emit}) {
        const title = ref("");

        const changeTitle = (newTitle) => {
            console.log("newTitle : " + newTitle)
        };

        const races = reactive({})
        const hasBet = (meeting) => {
            let hasBet = false

            meeting.bets.forEach(bet => {
                props.bets.forEach(userBet => {
                    if (userBet.id === bet.id) {
                        hasBet = true
                    }
                })
            })

            return hasBet
        }

        const pickCount = (meeting) => {
            let pickCount = 0;

            meeting.bets.forEach(bet => {
                props.bets.forEach(userBet => {
                    if (userBet.id === bet.id) {
                        pickCount = userBet.runners_count
                    }
                })
            })

            return pickCount
        }

        const updateTutorialStep = (tutorialStep) => {
            setTutorialStep(tutorialStep)

            emit('updateTutorialStep', tutorialStep)
        }

        const checkIfDisabled = (meeting, stoppingStep) => {
            return ((props.tutorialMeeting.value.id !== meeting.id || !(props.tutorialStep > stoppingStep)) && props.tutorialStep>0)
        }

        // Checks if the meeting meets the conditions to be a tutorial demonstrator.
        const checkIfTutorialMeeting = (meeting, step) => {

            // Create a filtered list of compatible meetings for tutorial.
            let chosenMeeting = {};
            chosenMeeting = props.meetings.filter(
                element => element.country_code == 'GB'
                    && element.jackpot.price == "0"
                    && element.hidden == 0
                    && element.abandoned == 0
                    && element.finished == false
                    && !hasBet(element));

            props.tutorialMeeting.value = chosenMeeting[Object.keys(chosenMeeting)[0]] || {};

            if (Object.keys(props.tutorialMeeting.value).length === 0) {


                if (step > 0) {

                    setTutorialStep(0);
                    emit('updateTutorialStep', 0)
                }

                return false;
            }

            return (    meeting.id === props.tutorialMeeting.value.id &&
                props.user.tutorial_step === step &&
                !meeting.finished )
        }
        
        const getRaces = (meetingId, open) => {
            if (!open && !races[meetingId]) {
                axios.get(route('api.races.index'), {
                    params: {
                        meeting_id: meetingId
                    }
                }).then(response => {
                    const sortedData = response.data.sort((a, b) => new Date(a.start_time) - new Date(b.start_time));
                    Object.assign(races, { [meetingId]: sortedData });
                    races[meetingId][races[meetingId].length] = {};
                });
            } else {
                delete races[meetingId];
            }
        }

        const isOpen = ref(false)
        const visibleMeetingId = ref(null)

        function setIsOpen(value) {
            isOpen.value = value
            console.log(isOpen.value)
        }

        function openModal(meetingId) {
            isOpen.value = true
            visibleMeetingId.value = meetingId
            console.log(visibleMeetingId)
            console.log(isOpen.value)
        }

        const isVisible = computed(() => (meetingId) => isOpen.value && meetingId === visibleMeetingId.value)

        return {
            races,
            getRaces,
            hasBet,
            pickCount,
            pickCount,
            checkIfTutorialMeeting,
            title,
            changeTitle,
            isOpen,
            setIsOpen,
            openModal,
            visibleMeetingId,
            isVisible,
            
        }

    }
}

</script>